import React, { Component } from 'react';

import {
  Card,
  CardTitle
} from 'rmwc/Card';

import { Icon } from 'rmwc/Icon';
import { IconToggle } from 'rmwc/IconToggle';

import { Elevation } from 'rmwc/Elevation';

import Actions from "./Actions";
import Display from "./Display";

import StateCalc from "./statecalc/statecalc.js";

import "./mdccalc.css";

const moon = <path d="M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z" />;
const sun  = <path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z" />;



class MDCCalc extends Component {
  constructor(props) {
    super(props);
    this.callCalc = this.callCalc.bind(this);
  }

  state = {
    night: false,
    calc: new StateCalc(),
    entry: 0,
    answer: 0,
    v1: 0,
    v2: 0
  }

  toggleNight() {
    if (!this.state.night) this.setState({ night: true })
    else this.setState({night: false});
  }

  callCalc(func, param) {
    if(this.state.calc.func) {
      this.state.calc[func](param);
    }

    this.setState({entry: this.state.calc.entry});
    this.setState({ answer: this.state.calc.answer });
    this.setState({ v1: this.state.calc.v1 });
    this.setState({ v2: this.state.calc.v2 });
  }

  render() {
    const night = this.state.night ? " mdc-calc-theme__night" : "";
    const classes = "mdc-calc" + night;
    return (
      <Card className={classes}>
        <div className="mdc-calc-title-bar">
          <CardTitle style={{"display": "block"}} className="mdc-calc-title">
            Calculator
          </CardTitle>
          <Icon onClick={this.toggleNight.bind(this)} className="mdc-calc-icon mdc-calc__sizing-content">
            <svg strategy="component">
              {this.state.night ? sun : moon}
            </svg>
          </Icon>
        </div>
        <Display entry={this.state.entry} ans={this.state.answer} />
        <Actions calc={this.callCalc} />
      </Card>
    );
  }
}

export default MDCCalc;



// WEBPACK FOOTER //
// ./src/MDCCalc/MDCCalc.js